export enum FileSizeEnum {
  TAMANHO_ARQUIVO_DEFAULT = 104857600 // Valores em bytes; (100MB)
}
